import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import React from 'react';
import Zoom from '@material-ui/core/Zoom';
import styles from './AddGroupCard.module.css';
import { Typography } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
const AddGroupCard = ({ toggleCreateModal, isSchool, disabled, isDemo, modifiers }) => {
  const isCorrectModifiers = () => {
    let hasPriority1 = false;
    let hasPriority2 = false;

    modifiers.forEach((el) => {
      if (el.priority === 1) hasPriority1 = true;
      if (el.priority === 2) hasPriority2 = true;
    });

    return hasPriority1 && hasPriority2 ? true : false;
  };
  const { t } = useTranslation();

  const title = () => {
    // if (isDemo) {
    //   if (isSchool) {
    //     if (disabled) {
    //       return 'Elérted a demo boltod galéria limitjét. Ha több iskolát szeretnél létrehozni, élesítsd boltodat!';
    //     } else {
    //       return 'Iskola Hozzáadása';
    //     }
    //   } else {
    //     if (disabled) {
    //       return 'Elérted a demo boltod galéria limitjét. Ha több osztályt szeretnél létrehozni, élesítsd boltodat!';
    //     } else {
    //       return 'Osztály Hozzáadása';
    //     }
    //   }
    // } else {
    if (isCorrectModifiers()) {
      if (isSchool) {
        if (disabled) {
          return t('groups.addGroupCard.disabledSchool');
        } else {
          return t('groups.addGroupCard.addSchool');
        }
      } else {
        if (disabled) {
          return t('groups.addGroupCard.disabledClass');
        } else {
          return t('groups.addGroupCard.addClass');
        }
      }
    } else {
      return t('groups.addGroupCard.firstStep');
    }
    // }
  };

  return (
    <Zoom in={true} timeout={1000}>
      <Card className={styles.cardStyle}>
        <Tooltip title={title()}>
          <CardActionArea
            disableRipple={disabled || !isCorrectModifiers()}
            className={!disabled && isCorrectModifiers() ? styles.cardActionArea : styles.cardActionAreaDisabled}
            onClick={!disabled && isCorrectModifiers() ? toggleCreateModal : undefined}>
            <AddCircleIcon className={styles.icon} />
            <Typography className={styles.cardTitle}>
              {isSchool ? t('groups.addGroupCard.addSchool') : t('groups.addGroupCard.createClass')}
            </Typography>
          </CardActionArea>
        </Tooltip>
      </Card>
    </Zoom>
  );
};

export default AddGroupCard;
